import "./jquery";
await import(/* webpackIgnore: true */ 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.4.1/tinymce.min.js');
let host = window.location.href.split('/');
tinymce.baseURL = "https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.4.1";
tinymce.suffix = '.min'
tinymce.init({
    selector: 'textarea.tinymce',
    plugins: "preview, autoresize, autolink, wordcount, link, autosave",
    promotion: false,
    contextmenu: "paste | link",
    toolbar: "restoredraft | undo redo | preview | blocks | link | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | paste | fontsizeselect | wordcount",
    default_link_target: "_blank",
    autosave_retention: '30m',
    autosave_interval: '15s',
    min_height: 500,
    block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;',
    relative_urls: false,
    document_base_url: "host[0]",
    paste_as_text: true
});
if (typeof afterTinyMceInit == 'function') {
    afterTinyMceInit();
}
$(".tinyfix").on("shown.bs.modal", function () {
    $(document).off("focusin.modal");
});